import React, { useRef, useState } from 'react';
import { iphoneRedeemCode, iphoneCricketStore } from '../../link-actions';

export const CricketBowlingBase = (props) => {
    let sportKey = "cricket";

    return (<div>
          <section className="atf-about-area atf-shape black-smoke-background" >

          <div className="non-landing-banner-clear"></div>
              <div className="container">
                  <div className="row clearfix justify-content-center"  >
                      {props.banner}
                  </div>
                  
              </div>

          </section>

          <section  style={{background: 'yellowgreen', padding: '5px'}}>
            <div className="container">
            {1==2 ? // Hide the special offer
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-6 col-12 text-center align-self-center">
                          <div>
                            <div style={{ fontSize: '24px', lineHeight: "1.3", color: "white", marginBottom:'10px', marginTop:'10px' }}><span style={{fontSize:'30px'}}>Get 66% off.</span><br/>T20 World Cup Special. </div>
                              <div style={{ fontSize: '18px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>Try for free then $0.99<span style={{fontSize: '14px'}}>/month*</span></div>
                              
                            </div>
                        </div>

                        <div className="col-lg-6 col-12 text-center align-self-center">
                          <div>
                            <div>
                                  <a href="#" onClick={() => iphoneRedeemCode("ANALYZER26")} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                                    
                              </div>

                              <div style={{ fontSize: '14px', lineHeight: "1.3", color: "var(--thm-black)", marginBottom:'10px' }}>(Normally $2.99<span style={{fontSize: '12px'}}>/month</span>)</div>
                              <div style={{ fontSize: '12px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>*USD. Prices vary per region. Cancel any time.<br/>Offer ends 9 Mar 2026</div>
                              
                              </div>
                        </div>
                    </div> 

                    :

                    <div className="row justify-content-center clearfix">
                      <div className="col-12 text-center align-self-center">
                          <div >
                            <div style={{ fontSize: '24px', lineHeight: "1.3", color: "white", margin:'20px 0 10px 0', fontFamily: 'Comfortaa', fontWeight: 'bold' }}>Try for free. Cancel any time.</div>
                              <div>
                                  <a href="#" onClick={() => iphoneCricketStore("cricket")} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                                    
                              </div>
                              </div>
                        </div>
                    </div> 
            }       
            </div>
            </section>

          {props.content}

          <section style={{paddingTop: '40px', backgroundColor: 'yellowgreen', padding: '20px'}}>
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-12 text-center align-self-center">
                          <div>
                              <h2 className='heading-size' style={{ marginTop: "5px", marginBottom: "10px", color:"white"}}>Analyze fundamentals</h2>
                              <p style={{ fontSize: "18px", margin: "15px 0 20px 0" }}>Get immediate visual feedback on a series of fundamentals.</p>
                          </div>
                      </div>

                  </div>
                  <div className="row clearfix align-self-center" >
                          <div className="col-lg-3 col-12 text-center" style={{padding: '2px'}}> 
                              <img src="./assets/img/cricket/bowling/elbow_angle_2.png" alt="Elbow angle" style={{width: "80%"}} />
                                <div style={{width: "100%", marginTop:"-30px"}}>
                                    <h2 style={{ fontSize: '22px', color:"white", fontFamily: 'Comfortaa' }}>Elbow Angle</h2>
                                </div>
                          </div>

                            <div className="col-lg-3 col-12 text-center" style={{padding: '2px'}}>
                                <img src="./assets/img/cricket/bowling/arm_angle_2.png" alt="Arm angle" style={{width: "80%"}} />
                                <div style={{width: "100%", marginTop:"-30px"}}>
                                    <h2 style={{ fontSize: '22px', color:"white", fontFamily: 'Comfortaa' }}>Arm Angle</h2>
                                </div>
                          </div>

                           <div className="col-lg-3 col-12 text-center" style={{padding: '2px'}}>
                                <img src="./assets/img/cricket/bowling/knee_angle.png" alt="Knee bend" style={{width: "80%"}} />
                                <div style={{width: "100%", marginTop:"-30px"}}>
                                    <h2 style={{ fontSize: '22px', color:"white", fontFamily: 'Comfortaa' }}>Knee Bend</h2>
                                </div>
                          </div>

                          <div className="col-lg-3 col-12 text-center" style={{padding: '2px'}}>
                                <img src="./assets/img/cricket/bowling/arm_alignment.png" alt="Arm/Leg alignment" style={{width: "80%"}} />
                                <div style={{width: "100%", marginTop:"-30px"}}>
                                    <h2 style={{ fontSize: '22px', color:"white", fontFamily: 'Comfortaa' }}>Body alignment</h2>
                                </div>
                          </div>

                  </div>
              </div>
          </section>
            { (1==2) &&<section className="atf-section-padding">
                      <div className="col-12 text-center align-self-center">
                          <div style={{backgroundColor: 'var(--thm-black)', padding: '20px'}}>
                            <div style={{ fontSize: '24px', lineHeight: "1.8", color: "white",  fontWeight: 'bold' }}>T20 World Cup Special</div>
                            <div style={{ fontSize: '20px', lineHeight: "1.8", color: "white", marginBottom:'10px', ffontWeight: 'bold' }}>Get 66% off until 9 Mar 2026.</div>
                              <div style={{ fontSize: '18px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>Try free then $0.99<span style={{fontSize: '14px'}}>/month*</span></div>
                              <div>
                                  <a href="#" onClick={() => iphoneRedeemCode("ANALYZER26")} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                              </div>
                              <div style={{ fontSize: '14px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>(Normally $2.99<span style={{fontSize: '12px'}}>/month</span>)</div>
                              <div style={{ fontSize: '12px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>*USD. Prices vary per region. Cancel any time.<br/>Offer ends 9 Mar 2026</div>
                              
                              </div>
                        </div>
          </section>}

          <section className="atf-section-padding">
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12 d-block d-lg-none  text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ marginTop: "5px", color:"var(--thm-black)"}}>Configure for any skill level and bowling style</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0"  }}>Set the threshold of a "good or bad" bowl to suit skill level and bowling style.</p>
                          </div>
                      </div>
                      <div className="col-lg-5 col-12 text-center">
                          <img src="./assets/img/cricket/bowling/configure_angle.png" alt="Configure settings" style={{width: '80%'}} />
                      </div>
                      <div className="col-lg-7 col-12  d-none d-lg-block  text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ marginTop: "5px", color:"var(--thm-black)"}}>Configure for any skill level</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0" }}>Set the threshold of a "good or bad" bowl to suit skill level and bowling style.</p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>

          <section className="atf-section-padding" style={{background: 'yellowgreen'}}>
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12 d-block d-lg-none  text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ marginTop: "5px", color:"white"}}>Stream replay to a tablet or laptop</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0", color:'white'  }}>Optionally connect a laptop or tablet to watch and analyze in your follow through.</p>
                          </div>
                      </div>
                      <div className="col-lg-5 col-12 text-center">
                          <img src="./assets/img/cricket/bowling/view_ipad.png" alt="Watch replay at your feet" style={{marginTop: '30px'}} />
                      </div>
                      <div className="col-lg-7 col-12  d-none d-lg-block  text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ marginTop: "5px", lineHeight: "1.5", color:"white"}}>Stream replay to a tablet or laptop</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0", color:'white' }}>Record from any angle and analyze on a tablet or laptop, in your follow through.</p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>

          <section className="atf-section-padding">
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12 text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ marginTop: "5px", color:"var(--thm-black)"}}>Save every bowl to watch later</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0",  }}>All bowls are automatically saved to your library, so you can re-watch them with a single tap.</p>
                          </div>
                      </div>
                      <div className="col-lg-5 col-12 text-center">
                          <img src="/assets/img/cricket/bowling/cricket_library.png" alt="Save individual bowls" style={{width: "80%"}}/>
                      </div>
                  </div>
              </div>
          </section>


          <section className="atf-section-padding" style={{background: 'yellowgreen'}}>
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12 text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ marginTop: "5px", lineHeight: "1.5", color:"white"}}>Stop practicing the wrong action</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0", color:"white"  }}>Try PracticeLoop and make sure your fundamentals are correct</p>
                              <div>
                                  <a href="#" onClick={() => iphoneCricketStore("cricket")} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                              </div>
                          </div>
                      </div>
                      <div className="col-lg-5 col-12 text-center">
                              <img src="./assets/img/cricket/bowling/arm_angle_3.png" alt="Analyze bowling action" style={{width: "80%"}} />
                      </div>
                  </div>
              </div>
          </section>
          <section className="atf-section-padding" style={{ paddingTop: "40px", paddingBottom: "0px" }}>
              <div className="container">
                  <div className="row justify-content-center" style={{backgroundColor: "yellowgreen"}}>
                      <div className="col-10 align-self-center text-center" style={{backgroundImage: 'url(assets/img/golf_collage.png)', backgroundSize: 'cover', backgroundPosition: 'center center'}}>
                          <div style={{ margin: '20px 10px 20px 10px', padding: '10px', background:"white"}}>
                              <h2 style={{ display: "inline-block", fontSize: '34px', lineHeight:"1.5", marginBottom: "10px", color:"var(--thm-black)",padding: "5px"}}>500+ installs</h2><br />
                              <h2 style={{ display: "inline-block", fontSize: '18px', marginBottom: "10px", lineHeight: "1.5", padding: "3px"}}>"See why PracticeLoop is the new way to learn to bowl"</h2>
                          </div>
                      </div>
                  </div>
              </div>
          </section>

          <div className="row justify-content-center clearfix" style={{backgroundColor:'var(--thm-black)',  marginTop: '30px', padding: '25px 5px'}}>
              <div className="col-12 text-center" style={{padding:"20px"}}>
                  <h2 className="heading-size" style={{ margin: "0 0 10px 0", color: 'yellowgreen' }}>Bowl. Analyze. Improve. Repeat.</h2>
                  <div style={{color:'white', fontSize:'20px', fontWeight:"normal", lineHeight:'2rem'}}>Instant feedback after every bowl</div>
                  <div style={{color:'white', fontSize:'20px', fontWeight:"normal"}}>so you can improve faster</div>
              </div>
          </div>

{1==2 &&
<section>
    <div className="container">
<div className="row justify-content-center clearfix">
                      <div className="col-12 text-center align-self-center">
                          <div style={{backgroundColor: 'yellowgreen', borderRadius: '10px', padding: '20px', marginTop: '30px', marginBottom: '30px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)'}}>
                            <div style={{ fontSize: '18px', lineHeight: "1.3", color: "#666666", marginBottom:'10px', fontFamily: 'Comfortaa', fontWeight: 'bold' }}>The best way to try</div>
                            <div style={{ fontSize: '24px', lineHeight: "1.3", color: "white", marginBottom:'10px', fontFamily: 'Comfortaa', fontWeight: 'bold' }}>T20 World Cup Starter Special</div>
                              <div style={{ fontSize: '20px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>Try free then $0.99<span style={{fontSize: '14px'}}>/month*</span></div>
                              <div>
                                  <a href="#" onClick={() => iphoneRedeemCode("ANALYZER26")} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                              </div>
                              <div style={{ fontSize: '16px', lineHeight: "1.3", color: "#666666", marginBottom:'10px' }}>(Normally $2.99<span style={{fontSize: '12px'}}>/month</span>)</div>
                              <div style={{ fontSize: '12px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>*USD. Prices vary per region. Cancel any time.<br/>Offer ends 9 Mar 2026</div>
                              
                              </div>
                        </div>
                    </div> 
                    </div>
</section>
}
          <div id="get-started" className="atf-section-padding atf-footer-offset">
              <div className="atf-brand-overlay">
                  <div className="container">
                      <div className="row justify-content-center clearfix wow fadeIn" data-wow-duration="1s" data-wow-delay="0.2s" data-wow-offset="0">
                          <div className="col-lg-8 col-md-8 col-11 text-center atf-mailchamp-headding atf-mailchamp-subscribe">
                              <h2 className="mb-1 text-center">Install the app</h2>
                              <div>
                                  <a href="#none" onClick={() => iphoneCricketStore(`${sportKey}_video_bottom_cta`)} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                                  </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    );
}

export default CricketBowlingBase;